<template>
    <v-container>
        <v-card width="" class="dt-border pad-10" flat>
            <v-container>
                <v-row class="pa-5 mb-5">
                    <div>
                        <h2>Profile</h2>
                    </div>
                    <!-- <v-spacer></v-spacer>
                    <div>
                        <v-btn @click="editable = !editable" :disabled ="editable" dark outlined color='primary' depressed>Edit Profile</v-btn>
                    </div> -->
                </v-row>
                <v-container class="profile">
                    <center>
                        <v-badge offset-x="30" offset-y="30" @click="fileUpload" bottom color="primary" icon="mdi-camera" bordered overlap>
                            <v-avatar @click="fileUpload" class="profile__picture dt-border" color="secondary" size="150">
                                <v-progress-circular
                                :size="30"
                                color="red"
                                v-if="loading"
                                indeterminate
                                ></v-progress-circular>
                                <v-icon v-if="!profilepicture && !loading" dark size="60">
                                    mdi-account-circle
                                </v-icon>
                                <img  v-if="profilepicture && !loading" :src="profilepicture" alt="">
                                <input
                                    type="file"
                                    name="file"
                                    class="inputfile d-none"
                                    ref="fileUpload"
                                    id="profile-image"
                                    @change="uploadProfileImage"
                                />
                            </v-avatar>
                        </v-badge>
                        <br><br>
                        <p style="cursor:pointer" @click="fileUpload">Change Profile Picture</p>
                    </center>
                    <v-row class="mt-10">
                        <v-col cols="12" md="6">
                            <label for="">First Name</label>
                            <v-text-field v-model="firstname" outlined color="red"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label for="">Last Name</label>
                            <v-text-field v-model="lastname" outlined color="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label for="">Phone Number</label>
                            <v-text-field :disabled="true" v-model="phonenumber" outlined color="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <label for="">Official Email Address</label>
                            <v-text-field :disabled="true" v-model="email" outlined color="auto"></v-text-field>
                        </v-col>
                    </v-row>
                    <br>
                    <center>
                        <v-btn :loading="loading2" depressed @click="update" dark color="primary">Update Profile</v-btn>
                    </center>
                </v-container>
                
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
// ======== IMPORT SERVICES ======
import { mapState } from "vuex";
// import { storageRef } from "@/utils/firebase.js";
import * as storageService from "@/utils/firebase/storage";
import { AdminService } from "@/services";

export default {
    data: () => ({
        loading:false,
        loading2:false,
        firstname:'',
        profilepicture:null,
        lastname:'',
        email:'',
        phonenumber:''
    }),
    computed:{
        ...mapState(["userDetails"])
    },
    mounted(){
        this.updateField();
    },
    methods:{
        updateField(){
            let source = this.userDetails
            this.firstname = source.profile.firstname;
            this.email = source.email;
            this.lastname = source.profile.lastname;
            this.phonenumber = source.phonenumber;
            this.profilepicture = source.profile.profilepicture
        },
        async uploadProfileImage(){
            this.loading = true;
            let date = Date.now();
            let path = 'Profile';
            let file = document.getElementById("profile-image").files[0];
            let pixName= this.userDetails.profile.firstname+'-'+date.toString();
            let image = await storageService.uploadImages(path, pixName, file);
            this.saveProfilePix(image)
        },
        async saveProfilePix(image){
            try {
                if(image){
                    let data = await AdminService.editProfile({
                        profilepicture : image
                    })
                    console.log(data);
                    this.profilepicture = image;
                    this.$store.dispatch("setUserInfo", data);
                    this.$store.dispatch("toast", {
                        message: "Profile Image Uploaded successfully",
                        variant: "success",
                    });
                    this.loading = false
                }   
            } catch (error) {
                console.log(error);
            }
        },
        fileUpload() {
            this.$refs.fileUpload;
            this.$refs.fileUpload.click();
        },
        async update(){
            try {
                this.loading2 = true;
                let payload = {
                    firstname : this.firstname,
                    middlename : this.middlename,
                    lastname : this.lastname,
                }
                let data = await AdminService.editProfile(payload);
                this.$store.dispatch("setUserInfo", data);
                this.$store.dispatch("toast", {
                    message: "Profile updated successfully",
                    variant: "success",
                });
                this.loading2 = false;
            } catch (error) {
                this.loading2 = false
                console.log(error);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.profile{
    &__picture{
        border: 3px solid orange !important;
        cursor: pointer;
        img{
            object-fit: cover;
            width: 100%;
            height: 100%;
            object-position: center;
        }
    }
}
</style>